import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DocumentDto } from '../../beneficiaries/beneficiary-details/documents/document.dto';
import { environment } from '../../environments/environment';
import { DocumentResponse } from '../models/enums/documentResponse.enum';
import { Pagination } from '../pagination/pagination';
import { PaginationOptions } from '../pagination/pagination-options';
import { ApiService } from './api.service';
import { FileService } from './file.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService {
  private readonly documentCreate: Subject<DocumentDto> = new Subject<DocumentDto>();
  public documentCreated$: Observable<DocumentDto> = this.documentCreate.asObservable();
  private readonly documentDelete: Subject<number> = new Subject<number>();
  public documentDeleted$: Observable<number> = this.documentDelete.asObservable();

  constructor(private readonly api: ApiService, private readonly fileService: FileService) {}

  public async findByBeneficiaryId(id: number, tag: string, options: PaginationOptions): Promise<Pagination<DocumentDto>> {
    const uri: string = environment.api.documents + '/beneficiary/' + tag + '/' + id;
    return this.api.getPaginated<DocumentDto>(options.buildUrl(uri));
  }

  public async downloadDocument(documentId: number, filename: string): Promise<void> {
    const uri: string = environment.api.documents + '/' + documentId;
    const data: Blob = await this.api.getFile(uri);
    return this.fileService.saveAs(data, filename);
  }

  public async deleteDocument(documentId: number): Promise<void> {
    const uri: string = environment.api.documents + '/' + documentId;
    await this.api.delete(uri);
    this.documentDelete.next(documentId);
  }

  public async saveDocument(documentDto: DocumentDto): Promise<DocumentResponse> {
    const result: string = await this.api.postString<DocumentDto>(environment.api.documents, documentDto);
    if (result === DocumentResponse.NoError) {
      this.documentCreate.next(documentDto);
    }
    return result as DocumentResponse;
  }

  public async downloadRib(filename: string, month: string, year: string, index: number): Promise<void> {
    const uri: string = environment.api.documents + '/ribs?month=' + month + '&year=' + year + '&index=' + index;
    const data: Blob = await this.api.getFile(uri);
    this.fileService.saveAs(data, filename);
  }
}
